<script>
import { mapActions, mapGetters } from 'vuex'
import ServiziActions from './ServiziAction'
import BackofficeAction from './BackofficeAction'

export default {
  name: 'HotelAction',
  mixins: [ServiziActions, BackofficeAction],
  methods: {
    ...mapActions(['addHotel', 'loadTrasferimenti']),
    ...mapGetters(['getSearch']),

    addHotelAction (hotel) {
      this.addHotel(hotel)
      const codiciTrasferimenti = this.searchTrasferimentiCodiciFromHotel()
      this.loadTrasferimentiFixed(codiciTrasferimenti, this.getSearch())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/HotelAction.vue